import { createFileRoute } from "@tanstack/react-router";

import { StrictContactId } from "@goose/schema/Salesforce";

export const Route = createFileRoute(
  "/_authenticated/opportunity/$opportunityId/contact/$contactId",
)({
  params: {
    parse: ({ contactId }) => {
      return {
        contactId: StrictContactId.parse(contactId),
      };
    },
  },
});
